import Typography from "Components/CommonComponents/Typography";
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { useEffect } from "react";
import "../index.css";
import { useState, useContext } from "react";
import cx from "classnames";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { UserInfoContext } from "Context/CommonContext";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import {
  BranchStatus,
  CORPORATE_BRANCH_CODE,
  Segments,
} from "utilFunctions/Constants/Constants";
import LeftArrow from "Assets/Icons/LeftArrow";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import FilterIcon from "Assets/Icons/FilterIcon";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useGlobalSearchContext from "Context/GlobalSearchContext";
// import CrossIcon from "Assets/Icons/CrossIcon";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
const ColStyled = styled<any>(Col)`
  display: flex;
  margin-left: 0px;
  flex-direction: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "row" : "column"};
  padding-right: 0px;
  padding-left: 0px;
  justify-content: end;
`;
const CardBodyStyled = styled<any>(CardBody)`
  padding: ${(props: any) =>
    ["xl", "xxl"].includes(props.screen) ? "16px" : "12px"};
`;
export const nullOption = [{ label: "All", key: "all", value: null }];

const BranchStudentFilter = ({
  filterState,
  setFilterState,
  applyFilter,
  resetHandler,
  location,
  businessUnit,
  studentAggregatedData,
}: any) => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const { screen }: any = useWindowSize();
  const { globalSearchData, saveGlobalSearchData } = useGlobalSearchContext();
  console.log(globalSearchData, "globalSearchData");
  const [stream, setStream] = useState<selectInterface[]>(
    masters?.streams ? nullOption.concat(masters.streams) : []
  );
  const [classes, setClassess] = useState<selectInterface[]>(
    masters?.classes ? nullOption.concat(masters.classes) : []
  );
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const preStreamFilter =
    location?.state?.filterState?.stream != undefined
      ? location?.state?.filterState?.stream
      : masters.streams && masters.streams[0] != undefined
      ? masters.streams[0]
      : null;
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [branch, setbranch] = useState<any>({
    branchName: null,
    branchCode: null,
  });
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Segments",
      nickName: "segment",
      data: Segments,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Status",
      nickName: "status",
      data: BranchStatus,
      singleSelect: false,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "stream",
        data: stream,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Segments",
        nickName: "segment",
        data: Segments,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Status",
        nickName: "status",
        data: BranchStatus,
        singleSelect: false,
        filterSelectedData: [],
      },
    ]);
  }, [masters?.streams, masters?.classes, masters?.branches]);
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, masters?.streams]);
  useEffect(() => {
    if (masters && masters.classes) {
      setClassess(masters?.classes);
    }
  }, [masters?.classes]);
  useEffect(() => {
    if (studentAggregatedData) {
      setbranch({
        branchName: studentAggregatedData && studentAggregatedData[0]?.value,
        branchCode: studentAggregatedData && studentAggregatedData[1]?.value,
      });
    }
  }, [studentAggregatedData]);

  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };
  const userBranchArray: any = userInfo.branch.split(",").map(Number);
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    applyFilter(obj, businessUnit);
    setFilterState(obj);
  };
  const handleClearAllFilter = () => {
    const clearedFilter = {
      stream: null,
      clazz: null,
      segment: null,
      status: null,
    };
    setFilterState(clearedFilter);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    resetHandler && resetHandler();
    setIsFilterApplied(false);
  };
  const isBranchDisabled = userBranchArray.includes(CORPORATE_BRANCH_CODE)
    ? false
    : true;
  const filterStateCopy = { ...filterState };
  if (preStreamFilter?.label == filterStateCopy?.stream?.label) {
    delete filterStateCopy["stream"];
  }
  const filterLength = Object.values(filterStateCopy).filter(
    (ele) => ele != null
  ).length;
  return (
    <div className="pl-5 pr-3">
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={globalSearchData?.isStudentHealth}
          setisPaneOpen={() => {
            saveGlobalSearchData({
              pathurl: null,
              isBranchHealth: false,
              isStudentHealth: false,
            });
          }}
          hideHeader={true}
          filterheadingListing={
            isBranchDisabled
              ? filterheadingListing.filter((ele) => ele.name != "Branch")
              : filterheadingListing
          }
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
        ></FilterSliderComponent>
      )}

      {["xxl", "xl", "lg"].includes(screen) && (
        <Card className="w-100 mt-3 branchHealthFilterCard">
          <CardBodyStyled screen={screen}>
            <CardTitle tag="h5" className="titleBar mb-0">
              <Row className="rowMain d-flex align-items-center mb-0">
                <Col
                  xxl="3"
                  xl="3"
                  lg="3"
                  md="4"
                  sm="6"
                  xs="6"
                  className="d-flex flex-row p-0 align-items-center"
                >
                  <LeftArrow
                    className={"cursorHoverCSS mr-3 mt-1"}
                    onClick={() => {
                      navigate("/admin/myBranch", {
                        replace: true,
                        state: {
                          selectedStudent: null,
                          selectedBranch: null,
                        },
                      });
                    }}
                  />
                  <Typography variant={"h6"} color="black">
                    {branch?.branchName} | {branch?.branchCode}
                  </Typography>
                </Col>
                {["xxl", "xl", "lg"].includes(screen) ? (
                  <ColStyled
                    screen={screen}
                    xxl="9"
                    xl="9"
                    lg="9"
                    md="8"
                    sm="6"
                    xs="6"
                  >
                    <Row className="w-100 d-flex justify-content-end align-items-center">
                      <Col xxl="2" xl="2" lg="2" md="3" sm="12" xs="12">
                        <CustomSelect
                          isSelected={filterState.stream != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Stream"
                          options={stream}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("stream", selected);
                          }}
                          value={filterState.stream}
                        />
                      </Col>
                      <Col xxl="2" xl="2" lg="2" md="3" sm="12" xs="12">
                        <CustomSelect
                          isSelected={filterState.clazz != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Class"
                          options={classes}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("clazz", selected);
                          }}
                          value={filterState.clazz ? filterState.clazz : null}
                        />
                      </Col>
                      <Col xxl="2" xl="2" lg="2" md="3" sm="12" xs="12">
                        <CustomSelect
                          isSelected={
                            filterState.segment != null ? true : false
                          }
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Segment"
                          options={Segments}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("segment", selected);
                          }}
                          value={filterState.segment}
                        />
                      </Col>
                      <Col xxl="2" xl="2" lg="2" md="3" sm="12" xs="12">
                        <CustomSelect
                          isSelected={filterState.status != null ? true : false}
                          width={"100%"}
                          top={"-3px"}
                          placeholder="Status"
                          options={BranchStatus}
                          isSearchable={false}
                          menuPlacement="bottom"
                          isClearable={false}
                          menuShouldScrollIntoView={true}
                          closeMenuOnSelect={true}
                          onChange={(selected: any) => {
                            handleAddFilterArrayList("status", selected);
                          }}
                          value={filterState.status}
                        />
                      </Col>

                      <Col
                        xxl={filterLength != 0 && isFilterApplied ? "2" : "2"}
                        xl={filterLength != 0 && isFilterApplied ? "2" : "2"}
                        lg={filterLength != 0 && isFilterApplied ? "2" : "2"}
                        md="3"
                        sm="12"
                        xs="12"
                        className="d-flex gap-2"
                      >
                        <Button
                          size="sm"
                          color="aeslPrimary"
                          onClick={() => {
                            applyFilter(filterState, businessUnit);
                            setIsFilterApplied(true);
                          }}
                          className="m-0"
                        >
                          Apply
                        </Button>
                        <div
                          onClick={() => {
                            if (filterLength != 0) {
                              handleClearAllFilter();
                            }
                          }}
                          className="d-flex justify-content-center align-items-center cursor-pointer"
                        >
                          <span
                            className={cx("filterSpan", "filterspanWidth", {
                              resetAllButtonStyle:
                                filterLength != 0 && isFilterApplied,
                            })}
                          >
                            Reset All{" "}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </ColStyled>
                ) : (
                  <Col
                    xxl="6"
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="6"
                    className="d-flex justify-content-end p-0"
                  >
                    {filterLength != 0 ? (
                      <div className="d-flex">
                        <div
                          className="clearAllButtonStyle cursorHoverCSS"
                          onClick={() => {
                            handleClearAllFilter();
                          }}
                        >
                          Clear All
                        </div>
                        <FilterIcon
                          onClick={() => {
                            setisPaneOpen(!isPaneOpen);
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center"
                        onClick={() => {
                          setisPaneOpen(!isPaneOpen);
                        }}
                      >
                        <span className="filterSpan">Filter</span>
                        <FilterIcon />
                      </div>
                    )}
                    {filterLength != 0 ? (
                      <div className="filterButtonTipMB">{filterLength}</div>
                    ) : null}
                  </Col>
                )}
              </Row>
            </CardTitle>
          </CardBodyStyled>
        </Card>
      )}
    </div>
  );
};
export default BranchStudentFilter;
